//en.js

const en = {
    message: {
        'GroupMember': "Group Member",
        'Publications': "Publications",
        'PhD': "PhD",
        'Master': "Master",
        'Teacher': 'Teacher',
        'Lang': 'Language',
        'Web': "Web pages",
        'Graduated': 'Graduated',
        'Intro': "Introduction",
        'CV': "CV",
        'Study': "Research directions",
        'News': "News",
    },
};

export default en